<template>
  <div class="field-group field-group-full privacy-field">
    <el-checkbox
      :model-value="consent"
      class="privacy-consent-checkbox"
      :class="{ 'privacy-consent-error': showError }"
      @update:model-value="emit('update:consent', $event)"
    >
      <span class="privacy-consent-text">
        He leído y acepto el
        <a
          href="#"
          class="privacy-consent-link"
          @click.prevent="emit('open-notice')"
        >
          Aviso de Privacidad
        </a>
        <span class="required-asterisk">*</span>
      </span>
    </el-checkbox>
    <span v-if="showError" class="field-error-message">
      Debes aceptar el Aviso de Privacidad para continuar
    </span>
  </div>
</template>

<script setup lang="ts">
defineProps<{ consent: boolean | undefined; showError: boolean }>();

const emit = defineEmits<{
  'update:consent': [value: unknown];
  'open-notice': [];
}>();
</script>

<style scoped src="./fields.css"></style>
<style scoped src="./privacy.css"></style>
